// src/components/Chatbot/Chatbot.js
import React, { useState } from "react";
import axios from "axios";
import styles from "../../css/Dashboard.module.css";

const Chatbot = () => {
  const [chatMessages, setChatMessages] = useState([
    { role: "bot", content: "Hello! How can I assist you?" },
  ]);
  const [userInput, setUserInput] = useState("");

  const handleUserInput = (e) => {
    setUserInput(e.target.value);
  };

  const handleSendMessage = async () => {
    if (!userInput.trim()) return;
    const messageToSend = userInput;
    setUserInput("");

    setChatMessages((prevMessages) => [
      ...prevMessages,
      { role: "user", content: messageToSend },
    ]);

    try {
      const response = await axios.post(
        "https://techservicemarket-backend.onrender.com/api/gpt/askGPT",
        {
          interaction: {
            role: "user",
            content: messageToSend,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setChatMessages((prevMessages) => [
        ...prevMessages,
        { role: "bot", content: response.data.message.message.content },
      ]);
    } catch (error) {
      console.error("Error sending message to chatbot:", error);
      setChatMessages((prevMessages) => [
        ...prevMessages,
        { role: "bot", content: "Sorry, something went wrong. Please try again." },
      ]);
    }
  };

  return (
    <div className={styles.chatbotContainer}>
      <div className={styles.chatHeader}>AI Chat Assistant</div>
      <div className={styles.chatHistory}>
        {chatMessages.map((message, index) => (
          <p
            key={index}
            className={
              message.role === "bot" ? styles.botMessage : styles.userMessage
            }
          >
            {message.content}
          </p>
        ))}
      </div>
      <div className={styles.chatInputContainer}>
        <input
          type="text"
          placeholder="Ask me anything..."
          className={styles.chatInput}
          value={userInput}
          onChange={handleUserInput}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleSendMessage();
          }}
        />
        <button className={styles.sendButton} onClick={handleSendMessage}>
          Send
        </button>
      </div>
    </div>
  );
};

export default Chatbot;
